import { Component, Input, Output, EventEmitter } from '@angular/core';

@Component({
  selector: 'app-e-drawer',
  templateUrl: './e-drawer.component.html',
  styleUrls: ['./e-drawer.component.css']
})
export class EDrawerComponent {
  @Input() title: string = '';
  @Input() isOpen: boolean = false;
  @Output() close = new EventEmitter<void>();

  closeDrawer() {
    this.close.emit();
  }
}



// WEBPACK FOOTER //
// /app/src/app/components/e-drawer/e-drawer.component.ts